import {useNavigate, useSearchParams} from "react-router-dom";
import {useEffect} from "react";
import {Spin} from "antd";
import {useAuth} from "@/provider/AuthProvider";
import {URLS} from "@/lib/urls";

export function LoginAs() {
    const [searchParams] = useSearchParams();
    const navigate = useNavigate();
    const {
        setUser,
        setAcademy,
        setUserAcademy,
        setRole,
        setDashboard,
        setBreadcrumb, user
    } = useAuth();
    useEffect(() => {


        localStorage.setItem('accessToken', searchParams.get('accessToken'));
        localStorage.setItem('academyData', '');
        localStorage.setItem('auth', '');


        setUser(null)
        setAcademy(null)
        setUserAcademy(null)
        setRole(null)
        setDashboard(null)
        setBreadcrumb(null)

        navigate(URLS.gateway.selector);

    }, [searchParams.get('accessToken')]);
    return (
        <div className={`flex flex-col justify-center items-center w-full h-full`}>

            <div className={`mt-64 flex flex-col justify-center items-center`}>
                <Spin size={`large`}/>
                <p className={`mt-8 `}>در حال ورود به سیستم ...</p>
            </div>
        </div>
    )
}
